var _defs, _g, _image, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVulnLow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill: #596564;\n      }\n\n      .cls-4 {\n        clip-rule: evenodd;\n      }\n\n      .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "42 6 83.1 78 1 78 42 6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.8,
    y: 33.5,
    width: 34.4,
    height: 31.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.5,61.9c-.3.5-.6.8-1.1,1.1-.5.3-1,.4-1.5.4h-25.9c-1.1,0-2-.6-2.6-1.5-.5-.9-.5-2.1,0-3l12.9-22.7c.3-.6.9-1.1,1.6-1.3.7-.2,1.4-.2,2,0,.7.2,1.2.7,1.6,1.3l12.9,22.7c.3.5.4,1,.4,1.5s-.1,1.1-.4,1.5h0ZM58.5,58.3l-12.9-22.7c-.5-.8-1.2-1.5-2.1-1.8-.9-.3-1.9-.3-2.8,0-.9.3-1.7,1-2.1,1.8l-12.9,22.7c-.7,1.3-.7,2.9,0,4.1.7,1.3,2.1,2.1,3.5,2.1h25.9c1.5,0,2.8-.8,3.5-2.1.7-1.3.7-2.9,0-4.1h0ZM42,58.9h0c-.4,0-.8-.4-.8-.8s.4-.8.8-.8h0c.4,0,.8.4.8.8s-.4.8-.8.8ZM42,56.1h0c-.7,0-1.3.4-1.7,1-.3.6-.3,1.3,0,1.9.3.6,1,1,1.7,1h0c.7,0,1.3-.4,1.7-1,.3-.6.3-1.3,0-1.9-.3-.6-1-1-1.7-1h0ZM42.9,52.7c0,.2,0,.4-.2.6-.2.2-.4.3-.6.3s-.4,0-.6-.3c-.2-.2-.2-.4-.2-.6v-9.5c0-.2,0-.4.2-.6.2-.2.4-.3.6-.3s.4,0,.6.3c.2.2.2.4.2.6v9.5ZM42,41.3c-.5,0-1,.2-1.4.6-.4.4-.6.9-.6,1.4v9.5c0,.5.2,1,.6,1.4.4.4.8.6,1.4.6.5,0,1-.2,1.4-.6.4-.4.6-.9.6-1.4v-9.5c0-.5-.2-1-.6-1.4-.4-.4-.8-.6-1.4-.6h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.3,
    y: 32,
    width: 37,
    height: 34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 5,
    width: 84,
    height: 74
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 37,
    height: 34,
    transform: "translate(23.3 32)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAjCAYAAAD48HgdAAAACXBIWXMAAAsSAAALEgHS3X78AAAECklEQVRYhc3Y2YvVdRjH8dd3xnHMpdS0zKXFiqDSyoJooWghwlKzzaAuKqjbuim67SL6AyKiS7sINFuMFqUC66KsEIoyK1rUaLFSc88Z9eni+R4dl+Occ3KsB4bz48z5fc/n2d7P8zv8T60ci0MioqCn/u1DXyll738qLCK6MA6XYTq2YhV+LKXs/k+EVVGTcT+uxk50oR/P4hPsKqXEcRNW03cqHpcRex5rMQLzcH0Vt6KU0tfp93QibGRE3BcRSyPi4ojoaQiOiFMi4rGIeCEiplYn2rKuDkV14TTMxxv4rpTSDzVtf+JVjMbNGHlchNUvnIddWIYdA/9ZStmHX/Aa5mJqdWbohEVEN87GTXgJvzcp7l14DxtxO04cMmG1VsbibnyDj9BX62p4RJwUEaMiomtAShfhOpwXEcOGRJgE6CWSWYuwuQoYjqvwKO7FxJq6Psm0z6sz41pthJaF1QNPxgJ8gDWllP76/oQqqhc3yjSPqKI3YzFmVIeGH1Nhkk/Xym58BVvq+904HWNkzX2MmVWkUsoefIt3q1MTWolaS8IG4OEOiYd1tfNISDdm5HZJ/+EOhvc22aFjZURPOCbCJB5uxR687RA8DGbViZ+xFLdhymD4GFRYxcNZEpSLsaGT2Scj+Y4c8vNl6jsXJsN/J36QeOhoY6jO/CGduwHnHg0fRxVW598MXC7xsLHDaDWsD59itWyEpvhoKmwAHu7Bh1jdmIedWnVqk4zaRZglG6d1YRIP12AaXnYAD//KKj6+xgoZtYlHitoRhdUPTpJ4eAtr21iVCwZL91bJwglybzsMH80iNhq31Os3JZ+aWciG6JaNMkYO8H3Nbqj4+Amvyw6dfCg+DhNW8XAmZmOJQfBQU7NedtxDcsVeZfDu3Ynl9XWeQfAhIsZHxJMR8VxETGplfERET0TMjIiHI2JORIxt8b7eiJgbEcsiYlYNChh2yAd7cAGuxFNax8Meue9vlZHa3uJ9fVgpuXYX1kXEplLKgbwegoeV+KINPIyqBz+NJzB9oPfNbMD2sQiXypWqh4NrrBdXyPGzBH+1oqgW7SQ8gC/r9Rwt7vnV+TVylVqA8RFRBgobI/fz5fJhtZ0n6UY99WOv9h8Lt8iHlykSvD1d7E/jOLnLr9DG9lBb/ze8KCO+TSJmZ5tn/IrP5Agc0Sj+bllf/TLnTRnUxLZjoSyBPdjawW8X/dLBqehuCNsrH7dC1tgGbWwRtYh3aHNPa1jN2BicIwd8/7DGwRGxRXbjg9geEeul90NtRU6a2TIoC/H3/iKt3TUNj+BCrNNZWtu1XpxRX5/B+6WUXQd1TxU3Xob0/Hp9TH5DO4r14Xt8JctpdynlyGOjbpa9knNDLSyquL6B0+IfCSC1bVh0ArcAAAAASUVORK5CYII="
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.3,
    y: 32,
    width: 37,
    height: 34
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 23.8,
    y: 32.5,
    width: 36.4,
    height: 33.1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulnLow);
export default __webpack_public_path__ + "static/media/vuln-low.cbcb6219ce99fcd7624a2b204579712b.svg";
export { ForwardRef as ReactComponent };